<div class="layout-dashboard">
	<div class="p-grid p-ai-start vertical-container">
		<div class="p-col-12 p-md-6 p-xl-6">
			<div class="card no-gutter widget-overview-box widget-overview-box-1">
				<div class="d-flex">
					<span class="overview-icon">
						<i class="pi pi-shopping-cart"></i>
					</span>
					<span class="overview-title">Venues</span>
				</div>

				<div class="p-grid overview-detail">
					<div class="col-6">
						<div class="overview-number">
							<p-skeleton *ngIf="!dealerService.dealer.value.counts"></p-skeleton>
							<span *ngIf="dealerService.dealer.value.counts">{{ onlineOrderVenueCount }}</span>
						</div>
						<div class="overview-subtext">Online Order</div>
					</div>
					<div class="col-6">
						<div class="overview-number">
							<p-skeleton *ngIf="!dealerService.dealer.value.counts"></p-skeleton>
							{{ dealerService.dealer.value.venues?.length }}
						</div>
						<div class="overview-subtext">FocusLink</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-6 p-xl-6">
			<div class="card no-gutter widget-overview-box widget-overview-box-2">
				<div class="d-flex">
					<span class="overview-icon">
						<i class="pi pi-dollar"></i>
					</span>
					<span class="overview-title">License Stats</span>
				</div>

				<div class="p-grid overview-detail">
					<div class="col-6">
						<div class="overview-number">
							<p-skeleton *ngIf="!dealerService.dealer.value.counts"></p-skeleton>
							{{ dealerService.dealer.value.counts?.onOrderLicenses }}
						</div>
						<div class="overview-subtext">FocusON</div>
					</div>
					<div class="col-6">
						<div class="overview-number">
							<p-skeleton *ngIf="!dealerService.dealer.value.counts"></p-skeleton>
							{{ dealerService.dealer.value.counts?.kitchen }}
						</div>
						<div class="overview-subtext">Kitchen</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
